define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Field",
	"csi/reflection",
	"SiteAdmin/DataSheetForm",
	"../ProductSpec/ProductBOMFormMixin"
], function(declare, lang, config, Field, reflection, DataSheetForm, ProductBOMFormMixin) {

	return declare([DataSheetForm, ProductBOMFormMixin], {

		_insertSubtypeField: function() {
			// summary: insert field for "Subtype" if there is any Active MaterialBOMSubtype
			if (this._hasActiveProductBOMSubtype()) {
				const {isRequired} = reflection.getClassAttribute(reflection.getClass("MaterialBOM"), "Subtype");

				this.insertField(lang.mixin(new Field(), {
					m_id: this.SUBTYPE,
					m_onChange: "onChangeBOMSubtype",
					m_bRequired: isRequired
				}), 0);
			}
		},

		_resolveView: function() {
			this._insertSubtypeField();
			this.inherited(arguments);

			// add BOMProductColors field if our parent is a Material (not a template)
			if (this.defView.getSource().getParent().$Type == "Material") {
				this.insertField(lang.mixin(new Field(), {
					m_id: "BOMProductColors",
					m_path: "Child:CurrentRevision"
				}));
			}
		}
	});
});